import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'
import { BLUE, MEDIUMORANGE } from '../../../../styles/colors.style'
import { breakpoints } from '../../../../constants'
import Button from '../../../../components/buttons/buttons.component'
import ReactHtmlParser from 'react-html-parser'

const StyledBackdrop = styled.div`
	position: fixed;
	background: rgba(0, 0, 0, 0.5);
	left: 0;
	top: 0;
	height: 100vh;
	width: 100vw;
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 4;

	@media screen and (min-width: 480px) {
		justify-content: center;
	}
`

const getWidth = ({ medium, large }) =>
	medium ? '600px' : large ? '900px' : 'auto'

const StyledModal = styled.div`
	background: #fff;
	padding: 25px;
	overflow: auto;
	width: calc(100% - 30px);
	border-radius: 5px;
	position: relative;
	box-sizing: border-box;
	max-height: calc(100vh - 70px);

	@media screen and (max-width: ${breakpoints.MOBILE}) {
		padding: 25px 10px 10px 10px;
	}

	@media screen and (min-width: 480px) {
		min-width: 300px;
		max-width: ${({ large }) => (large ? '900px' : '700px')};
		max-height: calc(100vh - 80px);
		width: ${getWidth};
	}

	${({ mobileFullWidth }) => (mobileFullWidth ? 'width: 100%;' : '')}

	.title {
		font-size: 3rem;
		text-align: left;
		user-select: none;
		line-height: 1em;
		border-bottom: solid 1.5px ${MEDIUMORANGE};
		padding-bottom: 5px;
	}

	.modal-content {
		font-size: 1.8rem;
		padding: 2rem 0;

		@media screen and (max-width: ${breakpoints.PHONE_LARGE}) {
			width: 260px;
		}
	}

	.fa-close {
		color: ${BLUE};
		position: absolute;
		right: 15px;
		top: 13px;
		cursor: pointer;

		@media screen and (max-width: ${breakpoints.MOBILE}px) {
			right: 5px;
			top: 0;
		}

		&:before {
			-webkit-text-stroke: 4px #fff;
		}
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		width: 70%;
	}
`

const StyledButtonWrapper = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;

	& > * {
		margin-top: 1rem;
		&:first-child {
			margin-top: 0;
		}
	}

	@media screen and (min-width: 480px) {
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;

		& > * {
			margin-top: 0;
			margin-right: 1.5rem;
			&:last-child {
				margin-right: 0;
			}
		}
	}
`

/**
 * Modal component
 * @param {boolean} noPadding Removes padding of modal
 *
 * @param {string} animation The modal opening transition (Animated.css)
 *
 */
class ModalError extends Component {
	constructor(props) {
		super(props)
		this.props = props
		this.state = {
			fade: false,
			animate: false,
		}
	}

	close = (callback) => {
		const { onClose } = this.props
		this.setState({ fade: true })
		setTimeout(() => {
			this.props.onClose && this.props.onClose()
			this.setState({ fade: false })
		}, 500)
		onClose()

		if (callback) callback()
	}

	componentWillReceiveProps({ isOpen }) {
		if (!this.props.isOpen && isOpen) {
			this.setState({ animate: true })
			setTimeout(() => {
				this.setState({ animate: false })
			}, 1000)
		}
	}

	getBackDropClass = () => (this.state.fade ? 'animated fadeOut' : '')

	getOpenClass = (animation) =>
		this.state.animate
			? !!animation
				? `animated ${animation}`
				: 'animated slideInDown'
			: ''

	render() {
		const { isOpen, message, animation, isInterstateRedirect } = this.props

		return message ? (
			isOpen ? (
				<StyledBackdrop
					className={`${this.getBackDropClass()} modal-opened`}
					onClick={() => this.close(isInterstateRedirect)}>
					<StyledModal
						onClick={(e) => e.stopPropagation()}
						className={this.getOpenClass(animation)}>
						<div>
							<FontAwesome
								name="close"
								size="3x"
								onClick={() => this.close(isInterstateRedirect)}
							/>
							<div className="title">Informação</div>
							<div className="modal-content">
								{ReactHtmlParser(message)}
							</div>
							<StyledButtonWrapper>
								<Button
									key="btn"
									primary
									onClick={() => this.close(isInterstateRedirect)}
									type="button">
									Fechar
								</Button>
							</StyledButtonWrapper>
						</div>
					</StyledModal>
				</StyledBackdrop>
			) : null
		) : null
	}
}

export default ModalError
